module.exports = __webpack_public_path__ + "img/android-scan-img.06d19d39.png";